<template>
  <toggle
    v-model="toggleValue"
    :active-text="$t('FeatureToggle_Enabled')"
    :inactive-text="$t('FeatureToggle_Disabled')"
    :disabled="disabled"
  />
</template>

<script>
import Toggle from '@/common/components/form/Toggle'
export default {
  name: 'FeatureToggle',
  components: { Toggle },
  props: {
    value: {
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    toggleValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/components/form/FeatureToggle.vue